import { useRef } from 'react';
import { Input, Modal } from 'antd';

import { useKeyword } from 'components/common';
import { classnames } from 'lib/classnames';
import useI18n from 'lib/hooks/useI18n';
import { MAX_MODAL_WIDTH } from 'lib/styles/width';

import WorkspaceTable from './workspaceTable';

import styles from './index.module.less';

const cx = classnames(styles);

const { Search } = Input;

interface WorkspaceModalProps {
  visible: boolean;
  handleOk: (selectedRowKeys: string[]) => void;
  handleCancel: () => void;
  selectedKeysRef?: React.MutableRefObject<string[]>;
}
const WorkspaceModal: React.FC<WorkspaceModalProps> = ({ visible, handleOk, handleCancel, selectedKeysRef }) => {
  const { keyword, onKeywordChange, setShowKeyword } = useKeyword();
  const tableRef = useRef(null);
  const { t } = useI18n();
  const handleSubmit = () => {
    handleOk(tableRef.current?.selectedRowKeys || []);
  };
  return (
    <Modal
      title={t('pages.settings.system.reIndexing.reIndexingChoose.btnMsg')}
      open={visible}
      onOk={handleSubmit}
      onCancel={handleCancel}
      width={MAX_MODAL_WIDTH}
      className={cx('workspace-modal')}
    >
      <Search
        className={cx('search')}
        value={keyword}
        placeholder={t('placeholder.workspace.searchWorkspaceName')}
        onChange={e => {
          setShowKeyword(e.target.value?.trim());
          onKeywordChange(e.target.value?.trim());
        }}
        allowClear
      />
      <WorkspaceTable keyword={keyword} tableRef={tableRef} selectedKeysRef={selectedKeysRef} />
    </Modal>
  );
};
export default WorkspaceModal;
